export const defaultReconnectChatPaneStartChatFocusedStyles = {
  content: "",
  inset: "0px",
  border: "1px solid transparent",
  outline: "rgb(96,94,92) solid 1px",
  zIndex: 1,
  boxShadow: "inset 0px 0px 0px 2px #fff"
};